export default __webpack_public_path__ + "static/media/money.e01b9401.png";